import { Square, Gauge, Zap, TriangleAlert, Hexagon, MapPin } from 'lucide-react';

// Severity → color (the single source the track, list, pins, and chips share).
export const SEVERITY_COLOR = { info: '#64748b', warn: '#f59e0b', critical: '#dc2626' };

// Event kind → lucide icon component.
export const KIND_ICON = {
  stop: Square,
  overspeed: Gauge,
  harsh: Zap,
  alert: TriangleAlert,
  geofence: Hexagon,
  poi: MapPin,
};

// Event kind → inner SVG markup for the matching lucide icon (verbatim lucide
// path data). Used to draw the SAME icon on raw-DOM map markers as the React
// <KIND_ICON> badges show on the track + timeline.
const KIND_ICON_PATHS = {
  stop: '<rect width="18" height="18" x="3" y="3" rx="2"/>',
  overspeed: '<path d="m12 14 4-4"/><path d="M3.34 19a10 10 0 1 1 17.32 0"/>',
  harsh: '<path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/>',
  alert: '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
  geofence: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>',
  poi: '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
};

/** Inline SVG string for an event kind's icon — for non-React DOM (map markers). */
export function kindIconSvg(kind, { size = 11, color = '#fff' } = {}) {
  const inner = KIND_ICON_PATHS[kind] || KIND_ICON_PATHS.stop;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

// Event kind → { labelKey, label } for the Type column / chips.
export const KIND_TYPE = {
  stop:      { labelKey: 'replayTypes.stop',      label: 'Stop' },
  overspeed: { labelKey: 'replayTypes.overspeed', label: 'Overspeed' },
  harsh:     { labelKey: 'replayTypes.harsh',     label: 'Harsh' },
  alert:     { labelKey: 'replayTypes.alert',     label: 'Alert' },
  geofence:  { labelKey: 'replayTypes.geofence',  label: 'Crossing' },
  poi:       { labelKey: 'replayTypes.poi',       label: 'POI visit' },
};
